export * from './src/SubscriptionQuoteStore'
export * from './src/SubscriptionQuoteClient'

        import * as me from '@peachy/subscription-client'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/subscription/client'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/subscription-client'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    